import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getEmploiInformationProgramsRequest: ['response'],
    getEmploiInformationProgramsSuccess: ['response', 'loading'],
    getEmploiInformationProgramsFailure: ['error'],
})

export const getEmploiInformationProgramsTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const getEmploiInformationProgramsSuccess = (state, { response }) =>
    state.merge({
        error: false,
        response,
        loading: false,
    })
const getEmploiInformationProgramsFailure = (state, { error }) =>
    state.merge({
        loading: false,
        error,
    })
const getEmploiInformationProgramsRequest = state =>
    state.merge({ loading: true, error: null })

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_EMPLOI_INFORMATION_PROGRAMS_REQUEST]: getEmploiInformationProgramsRequest,
    [Types.GET_EMPLOI_INFORMATION_PROGRAMS_SUCCESS]: getEmploiInformationProgramsSuccess,
    [Types.GET_EMPLOI_INFORMATION_PROGRAMS_FAILURE]: getEmploiInformationProgramsFailure,
})
